import { Quote } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLang } from "../config/i18n";

export const Depoimentos = () => {
  const { t } = useLang();

  return (
    <section data-testid="testimonials-section" className="relative py-24 sm:py-36 bg-[#121216] border-y border-[#22222B]">
      <div className="max-w-6xl mx-auto px-6">
        <Reveal className="max-w-3xl">
          <p className="text-[11px] font-semibold tracking-[0.3em] text-[#C5A059] uppercase mb-5">{t.depoimentos.overline}</p>
          <h2 className="font-heading text-3xl sm:text-4xl text-[#F7F7F8] leading-snug mb-4">{t.depoimentos.title}</h2>
          <p className="text-sm text-[#6E6E7D] font-light italic">{t.depoimentos.note}</p>
        </Reveal>
        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {t.depoimentos.items.map((item, i) => (
            <Reveal key={item.author} delay={i * 0.12}>
              <figure
                data-testid={`testimonial-card-${i + 1}`}
                className="h-full p-8 rounded-2xl bg-[#16161B] border border-[#22222B] hover:border-[#C5A059]/40 transition-colors duration-500 flex flex-col"
              >
                <Quote size={22} className="text-[#C5A059] mb-6" strokeWidth={1.4} />
                <blockquote className="flex-1 text-sm sm:text-[15px] text-[#D1D1DB] leading-relaxed font-light">
                  “{item.text}”
                </blockquote>
                <figcaption className="mt-7 text-[11px] tracking-[0.2em] uppercase text-[#C5A059]">
                  {item.author}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
